import { render, staticRenderFns } from "./InformationField.vue?vue&type=template&id=56011a1a&scoped=true&"
import script from "./InformationField.vue?vue&type=script&lang=js&"
export * from "./InformationField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56011a1a",
  null
  
)

export default component.exports